/******************************************************************
 * Archivo : client/src/components/Admin/roles/RoleForm/index.js
 * Proyecto: CB30
 * Módulo  : Administración de Roles
 *
 * Propósito:
 * Formulario para crear y editar Roles.
 *
 * Compatible con React 16.x
 ******************************************************************/

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { graphql } from "react-apollo";
import _ from "lodash";

// Queries
import fetchAllRoles from "../../../../queries/fetchAllRoles";
import fetchRoleById from "../../../../queries/fetchRoleById";
import fetchAllPermissions from "../../../../queries/fetchAllPermissions";


// Mutations
import createRole from "../../../../mutations/createRole";
import updateRole from "../../../../mutations/updateRole";



class RoleForm extends Component {

  state = {
    code: "",
    label: "",
    description: "",
    active: true,
    editing: false,
    permissions: []
    
  };

componentDidMount() {

 
  const { id } = this.props.match.params;

  if (id) {

    this.setState({
      editing: true
    });

    this.props.fetchRoleById.refetch({ id })
      .then(({ data }) => {

        const role = data.roleById;

        this.setState({

          code: role.code,
          label: role.label,
          description: role.description,
          active: role.active,
          permissions: (role.permissions || []).map(
          permission => permission.id
          )

        });

      });

  }

}


handlePermission = id => {

  let permissions = [...this.state.permissions];

  if (permissions.includes(id)) {

    permissions = permissions.filter(
      permissionId => permissionId !== id
    );

  } else {

    permissions.push(id);

  }

  this.setState({ permissions });

};


 handleSubmit = async e => {

  e.preventDefault();

  const {
    code,
    label,
    description,
    active
  } = this.state;

  console.log("Permisos seleccionados:", this.state.permissions);
  

if (this.state.editing) {

  await this.props.updateRole({

    variables: {

      id: this.props.match.params.id,
      code,
      label,
      description,
      permissions: this.state.permissions,
      active

    }

  });

} else {

  await this.props.createRole({

    variables: {

      code,
      label,
      description,
      permissions: this.state.permissions,
      active

    }

  });

}

this.props.history.push("/admin/roles");

this.props.history.push("/admin/roles");

};

  render() {

    const {
      loading,
      permissions = []
    } = this.props.fetchAllPermissions;

    const groupedPermissions = _.groupBy(
      _.orderBy(
      permissions,
      ["functionality", "order"],
      ["asc", "asc"]
    ),  
    "functionality"
    );

    console.log(Object.keys(groupedPermissions)[0]);
    console.log(Object.keys(groupedPermissions));

    return (

      <div className="container">

        <div className="row justify-content-center">

          <div className="col-lg-8">

            <div className="card shadow-sm">

              <div className="card-header bg-white">

                <h3 className="mb-1">
                  {
                  this.state.editing
                  ? "Editar Rol"
                  : "Nuevo Rol"
                  }
                </h3>

                <small className="text-muted">
                  Cree o modifique los roles del sistema.
                </small>

              </div>

              <div className="card-body">

                <form onSubmit={this.handleSubmit}>

                  <div className="form-row">

                    <div className="form-group col-md-4">

                      <label>

                        Código

                      </label>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="ADMIN"
                        value={this.state.code}
                        disabled={this.state.editing}
                        onChange={e =>
                          this.setState({
                            code: e.target.value.toUpperCase()
                          })
                        }
                      />

                    </div>

                    <div className="form-group col-md-8">

                      <label>

                        Nombre del Rol

                      </label>

                      <input
                        type="text"
                        className="form-control"
                        placeholder="Administrador"
                        value={this.state.label}
                        onChange={e =>
                          this.setState({
                            label: e.target.value
                          })
                        }
                      />

                    </div>

                  </div>

                  <div className="form-group">

                    <label>

                      Descripción

                    </label>

                    <textarea
                      rows="4"
                      className="form-control"
                      placeholder="Descripción del rol..."
                      value={this.state.description}
                      onChange={e =>
                        this.setState({
                          description: e.target.value
                        })
                      }
                    />

                  </div>

                  <div className="form-group">

                    <label>

                      Estado

                    </label>

                    <div className="custom-control custom-switch">

                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="roleActive"
                        checked={this.state.active}
                        onChange={() =>
                          this.setState({
                            active: !this.state.active
                          })
                        }
                      />

                      <label
                        className="custom-control-label"
                        htmlFor="roleActive"
                      >

                        {this.state.active
                          ? "Activo"
                          : "Inactivo"}

                      </label>

                    </div>

                  </div>

                  <hr />

                  <h5>

                    Permisos

                  </h5>

                  <p className="text-muted mb-4">

                    Seleccione los permisos que pertenecerán
                    a este rol.

                  </p>

                  <div className="card">

                    <div className="card-body">

                      <div className="row">

                    {Object.keys(groupedPermissions).map(functionality => (

  <div
    key={functionality}
    className="col-12 mb-4"
  >

    <h6
      className="font-weight-bold text-primary mb-3"
    >
      {functionality}
    </h6>

    <div className="row">

      {groupedPermissions[functionality].map(permission => (

        <div
          key={permission.id}
          className="col-md-6 mb-2"
        >

          <div className="custom-control custom-checkbox">

            <input
              type="checkbox"
              className="custom-control-input"
              id={permission.id}
              checked={this.state.permissions.includes(permission.id)}
              onChange={() => this.handlePermission(permission.id)}
            />

            <label
              className="custom-control-label"
              htmlFor={permission.id}
            >
              {permission.label}
            </label>

          </div>

        </div>

      ))}

    </div>

    <hr />

  </div>

))}   

                    </div>

                  </div>

                </div>

                  <div className="mt-4 d-flex justify-content-between">

                    <Link
                      to="/admin/roles"
                      className="btn btn-outline-secondary"
                    >
                      Cancelar
                    </Link>

                    <button
                      type="submit"
                      className="btn btn-primary"
                    >
                      Guardar Rol
                    </button>

                  </div>

                </form>

              </div>

            </div>

          </div>

        </div>

      </div>

    );

  }

}

export default graphql(fetchAllPermissions, {
  name: "fetchAllPermissions"
})(
  graphql(fetchRoleById, {
    name: "fetchRoleById",
    options: props => ({
      variables: {
        id: props.match.params.id
      },
      skip: !props.match.params.id
    })
  })(
    graphql(createRole, {
      name: "createRole",
      options: {
        refetchQueries: [{ query: fetchAllRoles }]
      }
    })(
      graphql(updateRole, {
        name: "updateRole"
      })(RoleForm)
    )
  )
);



// WEBPACK FOOTER //
// ./src/components/Admin/roles/RoleForm/index.js